import React from "react";
import { FaBullseye, FaUsers } from "react-icons/fa";
import missionImg from "../../assets/Ninja-pana.svg";
import teamImg from "../../assets/undraw_team-spirit_18vw.svg";

export default function WhatWeDo() {
  return (
    <div className="bg-gradient-to-br from-blue-50 via-white to-purple-50 py-10 sm:py-16 md:py-20 px-4 sm:px-6 md:px-10 text-gray-800">
      {/* Page Heading */}
      <h2 className="text-center text-3xl sm:text-4xl md:text-5xl font-extrabold mb-10 sm:mb-16 md:mb-20 text-purple-800 drop-shadow-sm">
        What We Do
      </h2>

      {/* Mission Section */}
      <section className="max-w-6xl mx-auto flex flex-col md:flex-row bg-gradient-to-tr from-orange-100 via-white to-orange-50 rounded-xl sm:rounded-2xl md:rounded-3xl shadow-lg sm:shadow-xl p-6 sm:p-8 md:p-10 mb-10 sm:mb-14 md:mb-16 border-l-4 sm:border-l-6 md:border-l-[10px] border-orange-400 hover:scale-[1.01] transition-all duration-300">
        <div className="w-full md:w-1/2 mb-4 sm:mb-6 md:mb-0 flex items-center justify-center">
          <img
            src={missionImg}
            alt="Our Mission"
            className="max-w-xs sm:max-w-sm w-full rounded-lg sm:rounded-xl shadow-sm sm:shadow-md max-h-48 sm:max-h-56 md:max-h-64 object-contain"
          />
        </div>

        <div className="w-full md:w-1/2 pl-0 md:pl-6 lg:pl-8">
          <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
            <FaBullseye className="text-orange-500 text-2xl sm:text-3xl md:text-4xl" />
            <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800">Our Mission</h3>
          </div>
          <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">
            Our mission is to{" "}
            <strong className="text-orange-600">empower young learners</strong> by sharing our experience from
            guiding over <strong>5,000 students</strong> across NSW. We help parents raise confident, resilient{" "}
            <strong className="text-orange-600">"warriors"</strong> who love learning, celebrate their wins, and grow from every challenge.
          </p>
        </div>
      </section>

      {/* Team Section */}
      <section className="max-w-6xl mx-auto flex flex-col-reverse md:flex-row bg-gradient-to-tr from-blue-100 via-white to-blue-50 rounded-xl sm:rounded-2xl md:rounded-3xl shadow-lg sm:shadow-xl p-6 sm:p-8 md:p-10 border-l-4 sm:border-l-6 md:border-l-[10px] border-blue-400 hover:scale-[1.01] transition-all duration-300">
        <div className="w-full md:w-1/2 pr-0 md:pr-6 lg:pr-8">
          <div className="flex items-center gap-3 sm:gap-4 mb-3 sm:mb-4">
            <FaUsers className="text-blue-500 text-2xl sm:text-3xl md:text-4xl" />
            <h3 className="text-xl sm:text-2xl md:text-3xl font-semibold text-gray-800">Our Team</h3>
          </div>
          <p className="text-sm sm:text-base md:text-lg text-gray-700 leading-relaxed">
            We are a team of dedicated educators and professionals passionate about guiding kids toward success.
            We've mentored <strong>5,000+ students face-to-face</strong> across NSW and built this platform to help
            parents raise <strong className="text-blue-600">lifelong learners</strong> who grow into confident warriors.
          </p>
        </div>
        <div className="w-full md:w-1/2 mb-4 sm:mb-6 md:mb-0 flex items-center justify-center">
          <img
            src={teamImg}
            alt="Our Team"
            className="max-w-xs sm:max-w-sm w-full rounded-lg sm:rounded-xl shadow-sm sm:shadow-md object-contain"
          />
        </div>
      </section>
    </div>
  );
}